import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToLegacyHash, scrollToSection } from "./utils/scrollToSection.ts";

function ScrollToHashElement() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") return;

    const hashFromUrl = window.location.hash;
    const legacyAnchor = hashFromUrl.includes("#")
      ? hashFromUrl.split("#").pop()
      : "";

    if (legacyAnchor && legacyAnchor !== "/" && !legacyAnchor.startsWith("/")) {
      const timer = window.setTimeout(() => scrollToLegacyHash(`#${legacyAnchor}`), 120);
      return () => window.clearTimeout(timer);
    }

    const pendingSection = sessionStorage.getItem("scrollToSection");
    if (pendingSection) {
      sessionStorage.removeItem("scrollToSection");
      const timer = window.setTimeout(() => scrollToSection(pendingSection), 120);
      return () => window.clearTimeout(timer);
    }
  }, [location.pathname, location.key]);

  return null;
}

export default ScrollToHashElement;
